import "./RoutineEmptyState.css";

type Props = {
  onAdd: () => void;
};

export function RoutineEmptyState({
  onAdd,
}: Props) {
  return (
    <section className="routine-empty-state">
      <div className="routine-empty-state__icon">
        ↻
      </div>

      <h2>No routines yet</h2>

      <p>
        Add a routine for habits, or a reminder for
        one important task.
      </p>

      <button
        type="button"
        onClick={onAdd}
      >
        Add routine
      </button>
    </section>
  );
}